<template>
  <div id="app">
    <div class="strongbow_loader" :style="{display: isLoaded?'none':'block'}">
      <div class="strongbow_loader_container">
        <div class="strongbow_loader-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
    <transition-group name="slide-fade">
      <template v-if="getAgeGateToken || $router.currentRoute.params.pathMatch === 'politics' || $router.currentRoute.params.pathMatch === 'cookies' || $router.currentRoute.params.pathMatch === 'tycos' || ($router.currentRoute.path === '/politics' && !getAgeGateToken) || ($router.currentRoute.path === '/cookies' && !getAgeGateToken) || ($router.currentRoute.path === '/tycos' && !getAgeGateToken)">
        <router-view v-if="$router.currentRoute.params.pathMatch === 'politics'" name="politics" key="politics"></router-view>
        <router-view v-else-if="$router.currentRoute.params.pathMatch === 'cookies'" name="cookies" key="cookies"></router-view>
        <router-view v-else-if="$router.currentRoute.params.pathMatch === 'tycos'" name="tycos" key="tycos"></router-view>
        <router-view v-else key="strongbow"></router-view>
        <!-- <BannerCookies key="bannercookies" /> -->
      </template>
    </transition-group>
    <transition-group name="slide-fade">
      <template v-if="!getAgeGateToken && ($router.currentRoute.path !== '/politics') && ($router.currentRoute.path !== '/cookies') && ($router.currentRoute.path !== '/tycos')">
        <AgeGate key="agegate" />
        <!-- <BannerCookies key="bannercookies" /> -->
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters  } from "vuex";

import AgeGate from "@/containers/AgeGatem";
import BannerCookies from "@/components/BannerCookies";

export default {
  name: "app",
  components: {
    AgeGate,
    BannerCookies,
  },
  data() {
    return {
      toggler: false,
    };
  },
  computed: {
    ...mapGetters(["getAgeGateToken", "isLoaded"]),
  },
  methods: {
    ...mapActions({
      setScrollMotionAction: "setScrollMotion",
      setEdgeScrollingAction: "setEdgeScrolling",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setLoadStatus: "setLoadStatus",
      setAgeGateTokenAction: "setAgeGateToken",

    }),
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.setScrollMotionAction("downEnd");
      } else if (scrollTop + clientHeight <= clientHeight + 5) {
        this.setScrollMotionAction("upStart");
      } else {
        this.setScrollMotionAction("scrolling");
      }
    },
    localStorageInclude(value) {
      let include  = false;
      for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        let _value = localStorage.getItem(key);
        if(_value === value){
          include = true
        }
      }
      return include
    },
    /*loadScripts() {
      const script1 = document.createElement('script');
      script1.src = "https://cdn-ukwest.onetrust.com/consent/4bcddd88-dbec-4a10-9578-5f74bb982a05/OtAutoBlock.js";
      document.head.appendChild(script1);
      const script2 = document.createElement('script');
      script2.src = "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js";
      script2.setAttribute('data-document-language', 'true');
      script2.setAttribute('type', 'text/javascript');
      script2.setAttribute('charset', 'UTF-8');
      script2.setAttribute('data-domain-script', '4bcddd88-dbec-4a10-9578-5f74bb982a05');
      document.head.appendChild(script2);
      const script3 = document.createElement('script');
      script3.textContent = "function OptanonWrapper() { }";
      document.head.appendChild(script3);
    }*/
    loadScripts() {
      const script1 = document.createElement('script');
      script1.src = "https://cdn.cookielaw.org/consent/0191467c-d70f-7b01-93a7-bf1fe7ef854e/OtAutoBlock.js";
      document.head.appendChild(script1);
      const script2 = document.createElement('script');
      script2.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
      script2.setAttribute('data-document-language', 'true');
      script2.setAttribute('type', 'text/javascript');
      script2.setAttribute('charset', 'UTF-8');
      script2.setAttribute('data-domain-script', '0191467c-d70f-7b01-93a7-bf1fe7ef854e');
      document.head.appendChild(script2);
      const script3 = document.createElement('script');
      script3.textContent = "function OptanonWrapper() { }";
      document.head.appendChild(script3);
    }
  },
  mounted() {
    //console.log('p', this.$router.currentRoute)
    const cookies = document.cookie;
    const OneTrustStorage = this.localStorageInclude('fc482041bb2d2f4b43ee11e07982dabd0c7de2aae21d3df7a093009908878b32');
    const OneTrustCookie = cookies.includes('fc482041bb2d2f4b43ee11e07982dabd0c7de2aae21d3df7a093009908878b32');
    if (OneTrustCookie || OneTrustStorage) {
      this.setAgeGateTokenAction(true);
    }
    window.onload = () => {
      this.setLoadStatus({status: true})
    }
    this.$nextTick(() => {});
    //console.log(this.$route.query)
    const query  = this.$route.query;
    localStorage.setItem('query', JSON.stringify(query));

    this.loadScripts();
  },
};
</script>

<style lang="scss">
@import "./styles/main.scss";

.strongbow_loader {
  background: linear-gradient(
    180deg
    ,$black 0,$black 100%);
      position: fixed;
      top: 0;
      left: 0;
      display: block;
      height: 100%;
      height: 100vh;
      width: 100%;
      width: 100vw;
      overflow: hidden;
      z-index: 100000000000;
      
  .strongbow_loader_container {
    position: absolute;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
    @media screen and (max-width: 768px) {
      top: 50%;
      left: 55%;
    }
    .strongbow_loader-roller {
      display: inline-block;
      position: relative;
      width: 120px;
      height: 120px;
    }
    .strongbow_loader-roller div {
      animation: strongbow_loader-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      transform-origin: 40px 40px;
    }
    .strongbow_loader-roller div:after {
      content: " ";
      display: block;
      position: absolute;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #fff;
      margin: -4px 0 0 -4px;
    }
    .strongbow_loader-roller div:nth-child(1) {
      animation-delay: -0.036s;
    }
    .strongbow_loader-roller div:nth-child(1):after {
      top: 63px;
      left: 63px;
    }
    .strongbow_loader-roller div:nth-child(2) {
      animation-delay: -0.072s;
    }
    .strongbow_loader-roller div:nth-child(2):after {
      top: 68px;
      left: 56px;
    }
    .strongbow_loader-roller div:nth-child(3) {
      animation-delay: -0.108s;
    }
    .strongbow_loader-roller div:nth-child(3):after {
      top: 71px;
      left: 48px;
    }
    .strongbow_loader-roller div:nth-child(4) {
      animation-delay: -0.144s;
    }
    .strongbow_loader-roller div:nth-child(4):after {
      top: 72px;
      left: 40px;
    }
    .strongbow_loader-roller div:nth-child(5) {
      animation-delay: -0.18s;
    }
    .strongbow_loader-roller div:nth-child(5):after {
      top: 71px;
      left: 32px;
    }
    .strongbow_loader-roller div:nth-child(6) {
      animation-delay: -0.216s;
    }
    .strongbow_loader-roller div:nth-child(6):after {
      top: 68px;
      left: 24px;
    }
    .strongbow_loader-roller div:nth-child(7) {
      animation-delay: -0.252s;
    }
    .strongbow_loader-roller div:nth-child(7):after {
      top: 63px;
      left: 17px;
    }
    .strongbow_loader-roller div:nth-child(8) {
      animation-delay: -0.288s;
    }
    .strongbow_loader-roller div:nth-child(8):after {
      top: 56px;
      left: 12px;
    }
  }
}

@keyframes strongbow_loader-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
